import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from 'store';
import { selectCompanyForMCEmployeeAction } from 'store/actions/auth-actions';
import { profileSelector } from 'store/selectors/profile-selectors';

// Handles the PLANNING_CREATED deep link delivered via push/email:
//   single planning   -> /planning?companyId={companyId}&contractId={contractId}
//   multiple plannings -> /planning?companyId={companyId}
// Switches to the correct company environment (multi-company employees), then routes
// to the specific planning or the planning overview.
const PlanningRedirect = (): JSX.Element => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const profile = useAppSelector(profileSelector);
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const companyId = searchParams.get('companyId');
    const contractId = searchParams.get('contractId');

    const navigateToPlanning = () => {
      if (contractId) {
        // The deleted-planning fallback (overview + banner) is handled in Contracts
        // when the linked planning can no longer be fetched.
        navigate(`/contracts/edit/${companyId}/${contractId}`, {
          replace: true,
          state: { fromPlanningDeepLink: true },
        });
      } else {
        navigate('/contracts', { replace: true });
      }
    };

    const handleRedirect = async () => {
      const hasMultipleCompanies = profile?.userCompanies && profile.userCompanies.length > 1;

      if (companyId && hasMultipleCompanies) {
        try {
          await dispatch(selectCompanyForMCEmployeeAction(Number(companyId))).unwrap();
        } catch (error) {
          // Navigate to the planning even if selecting company fails
        }
      }

      navigateToPlanning();
    };

    handleRedirect();
  }, [navigate, dispatch, searchParams, profile.userCompanies]);

  return null;
};

export default PlanningRedirect;
